import React, {useContext} from "react";
import { PostContext } from "../context/PostContext";

const Header= ()=>{
    const {dispatch}= useContext(PostContext);
    return(
        <header>
        <h1>orkut</h1>
        <button onClick={()=>dispatch({type: "CREATE_POST"})}>Create Post</button>
        </header>
    );
};

export default Header;